var cache = {};
/**
 * @return {string} Formated string MM'
 * @param {number} s Milliseconds to convert
 */
export var parseTimeFromSeconds = function (s) {
    var toSeconds = s;
    if (!cache[toSeconds]) {
        var sec = toSeconds % 60;
        var min = Math.ceil((toSeconds - sec) / 60);
        cache[toSeconds] = min.toString();
    }
    return cache[toSeconds];
};
//# sourceMappingURL=parseTimeFromSeconds.js.map